<template>
    <nav class="side-navbar">
      <div class="side-navbar-wrapper">
        <!-- Sidebar Header    -->
        <div class="sidenav-header d-flex align-items-center justify-content-center">
          <!-- User Info-->
          <div class="sidenav-header-inner text-center"><img src="static/images/logo.png" alt="logo" class="img-fluid">
            <h2 class="h5">Wtips <span>v3</span></h2>
          </div>
          <!-- Small Brand information, appears on minimized sidebar-->
          <div class="sidenav-header-logo"><a href="index.html" class="brand-small text-center"> <strong>V</strong><strong class="text-primary">3</strong></a></div>
        </div>
        <!-- Sidebar Navigation Menus-->
        <div class="main-menu">
          <h5 class="sidenav-heading">Main</h5>
          <ul id="side-main-menu" class="side-menu list-unstyled">                  
            <li><a href="./#/home"> <i class="icon-home"></i>Home</a></li>
            <li><a href="./#/customers"> <i class="icon-form"></i>Customers</a></li>
            <li><a href="./#/orders"> <i class="fa fa-bar-chart"></i>Orders</a></li>
            <li><a href="./#/post_order"> <i class="icon-grid"></i>Post Orders</a></li>
          </ul>
        </div>
        <div class="admin-menu">
          <h5 class="sidenav-heading">Admin menu</h5>
          <ul id="side-admin-menu" class="side-menu list-unstyled"> 
            <li> <a href="#"> <i class="icon-screen"> </i>Admin</a></li>
          </ul>
        </div>
      </div>
    </nav>	
</template>


<script>
export default {
  name: 'sidebar',
  props: {
      visible: {
            type:Boolean
              },
      viewing_page : {
            type : String
      }
  }

}
</script>




// WEBPACK FOOTER //
// src/components/supportcomp/sidebar.vue